import React from 'react';
import './GuestYouLike.less';

import CourseItem from '../../home/components/course/CourseItem';
import baseService from '../../../../lib/service/ServiceBase';

const markHash: string = '#guestyoulike';

/**
 * 可选参数
 */
interface IProps {
	getJumpUrl: (data: any) => string;
}

/**
 * 猜你喜欢
 */
class GuestYouLike extends React.PureComponent<IProps> {
	private refreshCache: boolean;

	public state: any = {
		courseList: {
			status: '',
			data: undefined,
			page: {
				size: 30,
			},
		},
		displaySize: 3,
		displayOffset: 0, // 当前显示的displaySize个课程所在的课程数组的偏移
	};

	/**
	 * componentDidMount
	 */
	public async componentDidMount(): Promise<any> {
		// 设置完标签回来，清空缓存重新请求
		if (typeof localStorage !== 'undefined') {
			try {
				if (Number(localStorage.getItem('CLEAN_RECOMMEND_GYL')) > 0) {
					localStorage.removeItem('CLEAN_RECOMMEND_GYL');
					this.refreshCache = true;
				}
			} catch (e) {}
		}

		await this.getCourse();

		const listData: any[] = this.state.courseList.data;
		if (listData && listData.length) {
			// 随机索引
			this.setState(
				{
					displayOffset: Math.floor(Math.random() * listData.length),
				},
				(): void => {
					// 如果选择完标签返回，定位到本模块
					if (typeof location !== 'undefined' && location.hash === markHash) {
						const dom: any = document.querySelector('.rec-guest-you-like');
						if (dom) dom.scrollIntoView();
					}
				}
			);
		}
	}

	private requestBuffer: any[] = [];

	/**
	 * requestCourse
	 */
	public requestCourse = (page: any): any => {
		return baseService
			.getPopularCourse({
				url: '/api/wechat/transfer/h5/live/center/popularCourse',
				method: 'POST',
				localCache: 24 * 60 * 60,
				refreshCache: this.refreshCache,
				body: {
					page,
				},
			})
			.then((res: any): void => {
				if (res.state.code) throw Error(res.state.msg);

				let list: any[] = res.data.courseList || [];
				let status: string = list.length < page.size ? 'end' : 'success';

				list = list.filter((item: any): boolean => item.displayStatus === 'Y');
				this.requestBuffer = this.requestBuffer.concat(list);

				// 如果本次请求结果过滤后长度不足displaySize，再请求
				// 20181026 改为只请求一次数据，30条，并缓存一天
				if (status !== 'end' && (this.requestBuffer.length < this.state.displaySize || this.requestBuffer.length < page.size)) {
					page.page++;

					return this.requestCourse(page);
				}
				// !
				status = 'end';

				const totalList: any[] = page.page === 1 ? this.requestBuffer : (this.state.courseList.data || []).concat(this.requestBuffer);

				this.requestBuffer = [];

				totalList.forEach((item: any, index: number): any => (item._index = index));

				this.setState({
					courseList: {
						...this.state.courseList,
						status,
						data: totalList,
						page,
					},
				});
			})
			.catch((err: any): void => {
				console.error(err);

				this.requestBuffer = [];
				this.setState({
					courseList: {
						...this.state.courseList,
						status: '',
					},
				});
			});
	}

	/**
	 * getCourse
	 */
	public getCourse = async (isContinue?: boolean): Promise<any> => {
		if (/pending|end/.test(this.state.courseList.status)) return null;

		const page: any = { ...this.state.courseList.page };
		page.page = isContinue ? Number(page.page) + 1 : 1;

		this.setState({
			courseList: {
				...this.state.courseList,
				status: 'pending',
			},
		});

		await this.requestCourse(page);
	}

	/**
	 * render
	 */
	public render(): any {
		const listData: any[] = this.state.courseList.data;

		if (!listData || !listData.length) return false;

		// 循环截取总数据量的displaySize
		const displayData: any[] = listData && (listData.length > this.state.displaySize ? listData.concat(listData).splice(this.state.displayOffset, this.state.displaySize) : listData);

		return (
			<div className="rec-guest-you-like">
				<div className="block-header">
					<span className="title">
						猜你喜欢
						<a
							className="learning-preference on-log on-visible"
							data-log-region="gyl-set-user-tag"
							data-log-status="A"
							// href
							href="/wechat/page/recommend/user-like?wcl=seo">
							<span className="icon"></span>
							点我设置学习偏好
						</a>
					</span>
					<a className="more-btn on-log" data-log-region="gyl-view-more" href="/wechat/page/recommend/view-more?regionCode=guestYouLike&wcl=seo">
						<span>
							更多<i className="check-more-icon"></i>
						</span>
					</a>
				</div>

				{displayData &&
					displayData.map((data: any, index: number): any => {
						return <CourseItem className="on-log on-visible" key={index} data={data} data-log-region="gyl-course-item" data-log-pos={data._index} data-log-status="A" isFlag={true} getJumpUrl={this.props.getJumpUrl} />;
					})}

				{!!(listData && listData.length > 3) && (
					<div className="refresh on-log on-visible" data-log-region="gyl-refresh" onClick={this.onClickRefresh}>
						换一换<i className={`icon_refresh${this.state.courseList.status === 'pending' ? ' loading' : ''}`}></i>
					</div>
				)}
			</div>
		);
	}

	public onClickRefresh = async (): Promise<any> => {
		const courseList: any = this.state.courseList;
		if (courseList.status === 'pending' || !courseList.data || !courseList.data.length) return null;

		// 数据量不够且还没加载完时，继续请求
		if (courseList.status !== 'end' && (this.state.displayOffset as number) + this.state.displaySize * 2 > courseList.data.length) {
			await this.getCourse(true);
		}

		const len: number = this.state.courseList.data.length;
		const newOffset: number = (this.state.displayOffset as number) + (this.state.displaySize as number);
		this.setState({
			displayOffset: newOffset > len - 1 ? newOffset - len : newOffset,
		});
	}
}

export default GuestYouLike;
